module.exports = __webpack_public_path__ + "media/enviro-short.3b3f92f5.mp4";